import { combineReducers } from '@reduxjs/toolkit';

import { accessTagsApi } from '~support-at-home/actions/accessTags';
import { accountCodesApi } from '~support-at-home/actions/accountCodes';
import { acoBudgetsApi } from '~support-at-home/actions/acoBudgets';
import { budgetPrintToSignRecordsApi } from '~support-at-home/actions/budgetPrintToSignRecords';
import { budgetsApi } from '~support-at-home/actions/budgets';
import { budgetExternalServicesApi } from '~support-at-home/actions/budgetServices';
import { budgetTrackerApi } from '~support-at-home/actions/budgetTracker';
import { careRecipientsApi } from '~support-at-home/actions/careRecipients';
import { claimsApi } from '~support-at-home/actions/claims';
import { clientHcpUnspentFundsApi } from '~support-at-home/actions/clientHcpUnspentFunds';
import { clientInvoicesApi } from '~support-at-home/actions/clientInvoices';
import { sahCompanyBudgetsApi } from '~support-at-home/actions/companyBudgets';
import { sahCompanyContributionsApi } from '~support-at-home/actions/companyContributions';
import { sahCompanyServicesApi } from '~support-at-home/actions/companyServices';
import { companyShiftsApi } from '~support-at-home/actions/companyShifts';
import { dashboardBudgetsApi } from '~support-at-home/actions/dashboardBudgets';
import { dashboardClaimItemsApi } from '~support-at-home/actions/dashboardClaimItems';
import { packageSchedulesApi } from '~support-at-home/actions/packageSchedules';
import { prodaConnectionApi } from '~support-at-home/actions/prodaConnection';
import { reconciliationsApi } from '~support-at-home/actions/reconciliations';
import { sahAcfrItemsApi } from '~support-at-home/actions/sahAcfrItems';
import { sahClientContributionsApi } from '~support-at-home/actions/sahClientContributions';
import { sahDashboardApi } from '~support-at-home/actions/sahDashboard';
import { sahProviderSummaryApi } from '~support-at-home/actions/sahProviderSummary';
import { sahReferenceDataApi } from '~support-at-home/actions/sahReferenceData';
import { sahReportsApi } from '~support-at-home/actions/sahReports';
import { sahServiceCutoverApi } from '~support-at-home/actions/sahServiceCutover';
import { sahServiceTypeAssociationsApi } from '~support-at-home/actions/sahServiceTypeAssociations';
import { statementBudgetsSummaryApi } from '~support-at-home/actions/statementBudgetsSummary';
import { statementsApi } from '~support-at-home/actions/statements';
import { supplierInvoicesApi } from '~support-at-home/actions/supplierInvoices';
import { userTagsApi } from '~support-at-home/actions/userTags';

import budgetServices from './budgetServices';
import clientBudgetStatuses from './clientBudgetStatuses';
import clientContributions from './clientContributions';
import clientServices from './clientServices';
import clientsWithBudgets from './clientsWithBudgets';
import externalApiStatuses from './externalApiStatuses';
import fundingTypes from './fundingTypes';
import pricePlanRevisions from './pricePlanRevisions';
import pricePlans from './pricePlans';
import sahBudgets from './sahBudgets';
import sahServiceTypeAssociations from './sahServiceTypeAssociations';
import supplierInvoices from './supplierInvoices';
import suppliers from './suppliers';

export const supportAtHome = {
  budgetServices,
  clientBudgetStatuses,
  clientContributions,
  clientServices,
  externalApiStatuses,
  pricePlanRevisions,
  pricePlans,
  sahBudgets,
  sahServiceTypeAssociations,
  supplierInvoices,
  suppliers,
  clientsWithBudgets,
  fundingTypes,
};

export default combineReducers(supportAtHome);

export const supportAtHomeApis = [
  accessTagsApi,
  accountCodesApi,
  budgetExternalServicesApi,
  budgetsApi,
  budgetPrintToSignRecordsApi,
  budgetTrackerApi,
  dashboardBudgetsApi,
  dashboardClaimItemsApi,
  sahAcfrItemsApi,
  claimsApi,
  clientInvoicesApi,
  clientHcpUnspentFundsApi,
  companyShiftsApi,
  packageSchedulesApi,
  prodaConnectionApi,
  reconciliationsApi,
  acoBudgetsApi,
  careRecipientsApi,
  sahClientContributionsApi,
  sahCompanyBudgetsApi,
  sahCompanyServicesApi,
  sahCompanyContributionsApi,
  sahDashboardApi,
  sahProviderSummaryApi,
  sahReferenceDataApi,
  sahServiceCutoverApi,
  sahServiceTypeAssociationsApi,
  statementBudgetsSummaryApi,
  statementsApi,
  supplierInvoicesApi,
  sahReportsApi,
  userTagsApi,
] as const;
